import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  color: ${({ theme }) => theme.colors.text.dark.very};
`;

const ActionLink = styled(Link)`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export default function SectionTitle({ title, actionText, actionLink }) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      {actionText && actionLink && (
        <ActionLink to={actionLink}>{actionText}</ActionLink>
      )}
    </Wrapper>
  );
}
